
// This is used to render the text and links on the left side of the account screen
export const navItems = [
  {
    "name": `Account Dashboard`,
    "url" : `/account`
  }
]
